export const EmployeeSearch = {
    searchText: "Tìm kiếm theo từ khoá Mã nhân viên, Tên nhân viên",
};

export const TitleBar = {
    title: "Danh sách nhân viên",
    addButtonText: "Tạo mới nhân viên",
};

export const EmployeeTableColumns = [
    { text: "Mã nhân viên", icon: <></> },
    { text: "Tên nhân viên", icon: <></> },
    { text: "Vai trò", icon: <></> },
    { text: "Số điện thoại", icon: <></> },
    { text: "Trạng thái", icon: <></> },
    { text: "", icon: <></> },
];

export const EmployeeRolesDropdown = [
    { text: "Quản lý", value: "MANAGER" },
    { text: "Quản lý Logistic", value: "LOGISTIC_MANAGER" },
    { text: "Nhân viên sale", value: "SALE_STAFF" },
    { text: "Nhân viên hậu cần sản xuất", value: "PRODUCTION_STAFF" },
    { text: "Nhân viên hậu cần mua hàng", value: "PURCHASING_STAFF" },
    { text: "Quản lý xưởng phuy thùng", value: "FACTORY_MANAGER_ONE" },
    { text: "Quản lý xưởng cơ khí ô tô", value: "FACTORY_MANAGER_TWO" },
    { text: "Phó quản lý xưởng phuy thùng", value: "DEPUTY_FACTORY_MANAGER_ONE" },
    { text: "Phó quản lý xưởng cơ khí ô tô", value: "DEPUTY_FACTORY_MANAGER_TWO" },
    { text: "Thủ kho 1", value: "FIRST_STORAGE_KEEPER" },
    { text: "Thủ kho 2", value: "SECOND_STORAGE_KEEPER" },
];